import {
    AnalyticsEvent,
    GTMEventData,
    EVENT_UAEVENT,
} from "@hermes/utils/analytics";

import {
    EVENT_PRODUCT_GRID,
    FILTERS,
    FILTERS_HIGHLIGHT,
} from "../constants/grid.constant";
import { GridFilter } from "../model/grid.model";

export interface GridFilterChangedEventPayload {
    gridFilter: GridFilter;
    gridFilterGroupName: string;
    isHighlightFilter: boolean;
}

export class GridFilterChangedEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = EVENT_UAEVENT;

    public eventData: GridFilterChangedEventPayload;

    constructor(gridFilterChangedEventPayload: GridFilterChangedEventPayload) {
        this.eventData = gridFilterChangedEventPayload;
    }

    public formatForGTM(): GTMEventData {
        return {
            event: EVENT_UAEVENT,
            eventcategory: EVENT_PRODUCT_GRID,
            eventaction: this.eventData.isHighlightFilter
                ? FILTERS_HIGHLIGHT
                : FILTERS,
            eventlabel: `${
                this.eventData.gridFilterGroupName
                // eslint-disable-next-line no-useless-escape
            }_${this.eventData.gridFilter.name.split(/[\s-\-]/gi).join("_")}`,
        };
    }
}
